// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_gGf","cls2":"PaperClaimedToast-cls2_wAR PaperClaimedToast-cls1_gGf"};